<template>
    <functional-calendar :configs="calendarConfigs" :key="key"></functional-calendar>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar';

export default {
    components: {
        FunctionalCalendar
    },

    props: {
        markedDates: {
            type: Array,
            default: function () { return [] }
        }
    },

    data() {
        return {
            calendarConfigs: {
                monthNames: this.getMonthNames(),
                dayNames: this.getDayNames(),
                sundayStart: false,
                dateFormat: 'dd-mm-yyyy',
                isDatePicker: false,
                isDateRange: false,
                isMultiple: true,
                calendarsCount: 3,
                markedDates: this.markedDates,
                leftAndRightDays: false
            },
            clientWidth: document.body.clientWidth
        }
    },

    created() {
        this.setCalendarsCount()

        window.addEventListener('resize', this.handleResize)
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },

    watch: {
        "locale": function (lang, oldLang) {
            if (lang !== oldLang && this.$store.state.langs.has(lang)) {
                this.calendarConfigs.monthNames = this.getMonthNames()
                this.calendarConfigs.dayNames = this.getDayNames()
            }
        }
    },

    computed: {
        locale: function () {
            return this.$i18n.locale()
        },
        key: function () {
            return this.clientWidth + '-' + this.locale
        }
    },

    methods: {
        handleResize(e) {
            this.clientWidth = document.body.clientWidth

            this.setCalendarsCount()
        },

        setCalendarsCount() {
            if (this.clientWidth < 768) {
                this.calendarConfigs.calendarsCount = 1
            } else if (this.clientWidth >= 768 && this.clientWidth < 992) {
                this.calendarConfigs.calendarsCount = 2
            } else if (this.clientWidth >= 992 && this.clientWidth < 1200) {
                this.calendarConfigs.calendarsCount = 3
            } else {
                this.calendarConfigs.calendarsCount = 4
            }
        },

        getMonthNames() {
            return [
                this.$t('January'),
                this.$t('February'),
                this.$t('March'),
                this.$t('April'),
                this.$t('May'),
                this.$t('June'),
                this.$t('July'),
                this.$t('August'),
                this.$t('September'),
                this.$t('October'),
                this.$t('November'),
                this.$t('December')
            ]
        },

        getDayNames() {
            return [
                this.$t('day.1'),
                this.$t('day.2'),
                this.$t('day.3'),
                this.$t('day.4'),
                this.$t('day.5'),
                this.$t('day.6'),
                this.$t('day.7')
            ]
        }
    }
}
</script>
